import React, { useState } from "react";
import TownPlanningSidebar from "../components/TownPlanningSidebar";
import styles from "../styles/TownPlanningDashboard.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FaArrowLeft, FaSearch, FaDownload, FaFilter, FaCalculator, FaFilePdf } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

import { faBars } from "@fortawesome/free-solid-svg-icons";

export default function Disclaimer() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const handleBack = () => {
    navigate("/")
  };
  return (
    <div
      className={styles.homeScreenContainer}
      style={{
        height: "100vh",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Header */}
      <div className={styles.homeScreenHeader}>
        {/* <button
          onClick={() => setIsSidebarOpen(true)}
          className={styles.homeScreenMenuBtn}
        >
          <FontAwesomeIcon icon={faBars} />
        </button> */}


        <button className={styles.homeScreenMenuBtn} onClick={handleBack}>
          <FaArrowLeft />
        </button>


        <TownPlanningSidebar
          isOpen={isSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
        />

        <h2 style={{ color: "white" }}>Disclaimer</h2>
      </div>

      {/* Scrollable Content Area */}
      <div
        style={{
          flex: 1,
          overflowY: "auto",
          padding: "20px",
          color: "white",
        }}
      >
        {/* <p style={{ textAlign: "justify" }}>
      * The app developer or promoter is "NOT A GOVERNMENT ENTITY NOR AFFILIATED WITH ONE".
* Through this app, we aim to provide a curated collection of publicly available documents & general information which is sourced from government websites/ portals like maharashtra.gov.in, dtp.maharashtra.gov.in, urban.maharashtra.gov.in, and social media public groups.
* All information is provided solely for reference. Its authenticity is not guaranteed, and it should not be relied upon in legal proceedings or official matters. 
* The app is not designed to address the specific circumstances of any individual or organization. For specific legal, professional, or administrative advice, users are encouraged to consult a qualified professional or contact the relevant government office directly. 
* The owner or developer does not assume any responsibility or liability regarding the completeness, accuracy, or timeliness of the content. 
* Some sections may link to external websites beyond the control of the owner or developer, who cannot be held accountable for their content.
 </p> */}


<ul style={{ textAlign: "justify", paddingLeft: "20px" }}>
  <li>
    The app developer or promoter is <strong>NOT A GOVERNMENT ENTITY NOR AFFILIATED WITH ONE</strong>.
  </li>

  <li>
    Through this app, we aim to provide a curated collection of publicly available documents and general information sourced from government websites/portals such as maharashtra.gov.in, dtp.maharashtra.gov.in, urban.maharashtra.gov.in, and public social media groups.
  </li>

  <li>
    All information is provided solely for reference. Its authenticity is not guaranteed, and it should not be relied upon in legal proceedings or official matters.
  </li>

  <li>
    The app is not designed to address the specific circumstances of any individual or organization. For specific legal, professional, or administrative advice, users are encouraged to consult a qualified professional or contact the relevant government office directly.
  </li>

  <li>
    The owner or developer does not assume any responsibility or liability regarding the completeness, accuracy, or timeliness of the content.
  </li>

  <li>
    Some sections may link to external websites beyond the control of the owner or developer, who cannot be held accountable for their content.
  </li>
</ul>

        {/* <p style={{ textAlign: "justify" }}>
          Some sections may link to external websites beyond the control of the owner or developer, who cannot be held accountable for their content.

        </p> */}

        {/* <p style={{ textAlign: "justify" }}>
          All information is provided solely for reference. Its authenticity is not guaranteed, and it should not be relied upon in legal proceedings or official matters. The app is not designed to address the specific circumstances of any individual or organization. For specific legal, professional, or administrative advice, users are encouraged to consult a qualified professional or contact the relevant government office directly.
        </p> */}
      </div>
    </div>
  );
}
